import React from 'react'
import { Carousel } from '../../components/carousel'
import { useCachedRequest } from '../../request'
import { Tooltip } from '../../components/simple/tooltip'
import { useAppContext } from '../../providers/context'

interface Card {
  id: number
  value: string
  icon: string
  text: string
  subtext?: string
  tip?: string
}

export const StatsCarousel: React.FC = React.memo(() => {
  const { state } = useAppContext()
  const { data } = useCachedRequest<Card[]>('/frontend_api/getStatsCarousel', state.user?.id)
  const cards = data || []

  return (
    <Carousel>
      {cards.map((card) => (
        <Tooltip text={card.tip} key={card.id}>
          <div className={`flex h-full w-full flex-col rounded-md bg-white p-6 shadow-special`}>
            <div className="flex justify-between">
              <div className="text-[35px] font-bold leading-none text-[#eb685c]">{card.value}</div>
              <img src={card.icon} alt="" className="h-9" />
            </div>
            <div className="mt-3">{card.text}</div>
            {card.subtext && <small className="leading-none opacity-35">{card.subtext}</small>}
          </div>
        </Tooltip>
      ))}
    </Carousel>
  )
})
